import React from 'react';
import { ViewMode } from '../types';
import { ICONS } from '../constants';
import { useTranslation } from '../hooks/useTranslation';

interface ViewModeToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  viewMode,
  onViewModeChange,
}) => {
  const { t } = useTranslation();
  
  const viewButtonClasses = (mode: ViewMode) =>
    `p-2 rounded-md transition-colors ${
      viewMode === mode
        ? 'bg-indigo-600 text-white'
        : 'text-gray-400 hover:text-white hover:bg-gray-600'
    }`;

  const handleGridClick = () => {
    onViewModeChange(ViewMode.GRID);
  };

  const handleListClick = () => {
    onViewModeChange(ViewMode.LIST);
  };

  return (
    <div className="bg-gray-800 p-1 rounded-lg flex items-center border border-gray-700">
      <button 
        onClick={handleGridClick} 
        className={viewButtonClasses(ViewMode.GRID)} 
        aria-label="Grid View"
        title={t('viewModes.grid')}
        type="button"
      >
        <ICONS.Grid className="w-5 h-5" />
      </button>
      <button 
        onClick={handleListClick} 
        className={viewButtonClasses(ViewMode.LIST)} 
        aria-label="List View"
        title={t('viewModes.list')}
        type="button"
      >
        <ICONS.List className="w-5 h-5" />
      </button>
    </div>
  );
};

export default ViewModeToggle;
